import React from "react";
import App from "./PortfolioComponents/App";

// New Method -> React 16 and above
import ReactDOM from "react-dom/client";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Old Method -> React 15 and below (React 17 supports)
// import ReactDOM from "react-dom";
// ReactDOM.render(<App />, document.getElementById("root"));
